import {useState, useEffect, useRef} from "react";

function OTPInput({ onOtpChange }) {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputsRef = useRef([]);

    useEffect(() => {
        inputsRef.current[0].focus();
    }, []);

    const handleChange = (element, index) => {
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        if (element.value.length === 1 && index < 5) {
            inputsRef.current[index + 1].focus();
        }

        if (!newOtp.includes('')) {
            onOtpChange(newOtp.join(''));
        }
    };

    const handleBackspace = (element, index) => {
        if (index > 0 && element.value === '') {
            inputsRef.current[index - 1].focus();
        }
    };

    return (<div className="flex flex-col space-y-16 mt-2">
            <div className="flex flex-row justify-between mx-auto w-full max-w-xs">
                {otp.map((data, index) => (
                    <div className="w-8 h-8" key={index}>
                        <input
                        className="block w-full rounded-md border-0 py-1.5 text-center text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        ref={ref => inputsRef.current[index] = ref}
                        type="text"
                        value={data}
                        maxLength="1"
                        onChange={e => handleChange(e.target, index)}
                        onKeyDown={e => e.key === 'Backspace' && handleBackspace(e.target, index)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default OTPInput;